//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    compilation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      socialShow: false
    }
  },
  methods: {
    clickToShare () {
      this.socialShow = !this.socialShow
    },
    share(name) {
      let url
      const picture = `${window.location.origin || 'https://my.tretyakov.ru'}${this.compilation?.desktopPicture?.src}`
      const title = this.compilation.seo.title || this.compilation.title
      const description = this.compilation.seo.description || this.compilation.text1
      const image = picture ? picture : ''
      const shortUrl = `${window.location.origin || 'https://my.tretyakov.ru'}/app${this.$route.path}`

      switch(name) {
        case 'vk':
          url = `https://vk.com/share.php?url=${shortUrl}&title=${title}&description=${description}`
          if (image) {
            url += `&image=${image}`
          }
          break
        case 'ok':
          url = `https://connect.ok.ru/offer?url=${shortUrl}&title=${title}&description=${description}`
          if (image) {
            url += `&imageUrl=${image}`
          }
          break
        case 'tg':
          url = `//telegram.me/share/url?url=${shortUrl}&text=${description}`
          break
        default:
          return
      }
      this.popup(url)
    },
    popup (url) {
      const social_window = window.open(url, "share_window", `height=500,width=800,top=${window.innerHeight / 2 - 250},left=${window.innerWidth / 2 - 400}`);
      social_window.focus();
    }
  }

}
